import React, { useState, useEffect } from "react";
import {
  Box,
  Grid2,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  FormControl,
  Grid,
  IconButton,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import HeaderBack from "../Header_Back";
import events2 from "../../assets/images/events_2.png";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useNavigate, useParams } from "react-router-dom";
import rupee from "../../assets/images/rupee.svg";
import useRequests from "../../utils/useRequests";
import { format } from "date-fns";
import Minus from "../../assets/images/minus.svg";
import Plus from "../../assets/images/plus.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import Snackbars from "../../utils/Snackbars";

const Myeventsdetails = () => {
  const { ut_id } = useParams();
  const [loading, setLoading] = useState(true);
  const { getRequest, postRequest } = useRequests();

  const [open, setOpen] = useState(false);


  const navigate = useNavigate();

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [detail, setDetail] = useState({
    type: "",
    day_pass: "",
    quantity: "",
    name: "",
    address: "",
    start_datetime: "",
    end_datetime: "",
    time: "",
    banner: "",
    event_ticket_date: "",
    purchase_price: "",
    purchase_date: "",
    resell_max: "",
    resell_min: "",
    assigned_organizer: ""
  });

  const [quantity, setQuantity] = useState(1);
  const handleIncrement = () => {
    if (quantity < detail.quantity) setQuantity(quantity + 1);
  };
  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const [formData, setFormData] = useState({
    selling_price: "",
  });

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: formData,

    validationSchema: Yup.object({
      selling_price: Yup.number()
        .required("Selling Price is required")
        .min(
          detail.resell_min * quantity,
          `Selling Price must be at least ${detail.resell_min * quantity}`
        )
        .max(
          detail.resell_max  * quantity,
          `Selling Price cannot be more than ${detail.resell_max * quantity}`
        ),
    }),
    onSubmit: async (values) => {
      // e.preventDefault();
      try {
        let submit1 = document.getElementById("submit1");
        submit1.disabled = true;
        submit1.textContent = "Processing...";
        if (
          detail.aadhar == "" ||
          detail.aadhar == undefined ||
          detail.aadhar == null
        ) {
          setAlertData({
            variant: "error",
            message: "Update Aadhar in Profile to Resell Ticket!",
          });
          resetAlertData();
          return;
        }

        if(detail.resellstatus == "Off"){
            setAlertData({
              variant: "error",
              message: "Ticket reselling is not activated!",
            });
            resetAlertData();
            return;
          }

          if(detail.assigned_organizer != 0){
            setAlertData({
              variant: "error",
              message: "Ticket assigned by organizer can't be resell!",
            });
            resetAlertData();
            return;
          }

          if(detail.used == true){
            setAlertData({
              variant: "error",
              message: "Used ticket can't be resell!",
            });
            resetAlertData();
            return;
          }

          const today = new Date();
          today.setHours(0, 0, 0, 0);
        if(detail.event_ticket_date){
            if(today > new Date(detail.event_ticket_date)){
              setAlertData({
                variant: "error",
                message: "Your ticket is expired!",
              });
              resetAlertData();
              return;
            }
        }
        else if(today > new Date(detail.end_datetime) ){
          setAlertData({
            variant: "error",
            message: "Your ticket is expired!",
          });
          resetAlertData();
          return;
        }

        const jsonpar = JSON.stringify({
          ut_id: ut_id,
          selling_price: values.selling_price,
          quantity: quantity,
        });
        const res = await postRequest("resell-ticket", jsonpar);
        if (res && res.code === 200) {
          setFormData({
            selling_price: "",
          });
          navigate(`/my-tickets/events-details/confirmation/${res.data.r_id}`);
        } else {
          setAlertData({
            variant: "error",
            message: res.message || "Failed to resell ticket.",
          });
          resetAlertData();
        }
        submit1.disabled = false;
        submit1.textContent = "Resell Ticket";
      } catch (error) {
        console.error("Error: ", error);
        setAlertData({
          variant: "error",
          message: "An error occurred while reselling ticket.",
        });
        resetAlertData();
      }
    },
  });

  const fetchTicketDetails = async () => {
    setLoading(true);
    try {
      const response = await getRequest(`ticket-details/${ut_id}`);
      if (response && response.code === 200) {
        const data = response.data;
        const calculatedMaxDays = calculateMaxEventDays(data.start_datetime, data.end_datetime);
        setMaxEventDays(calculatedMaxDays);   
        setDetail({
          type: data.type,
          day_pass: data.day_pass,
          quantity: data.quantity,
          name: data.name,
          address: data.address,
          start_datetime: data.start_datetime,
          end_datetime: data.end_datetime,
          time: data.start_time + " - " + data.end_time,
          banner: data.banner,
          event_ticket_date: data.event_ticket_date,
          purchase_price: data.purchase_price,
          purchase_date: data.purchase_date,
          resell_max: data.resell_max,
          resell_min: data.resell_min,
          assigned_organizer: data.assigned_organizer,
          used: data.used,
          resold_quantity: data.allready_resale_ticket,
          resellstatus: data.resellstatus,
          aadhar: data.aadhar,
        });
        console.log("banner", data.banner);
      } else {
        setAlertData({
          variant: "error",
          message: response.message || "Failed to fetch ticket details",
        });
      }
    } catch (error) {
      setAlertData({ variant: "error", message: "Something went wrong!" });
    }
    setLoading(false);
    resetAlertData();
  };

    const [maxEventDays, setMaxEventDays] = useState(1);
    const calculateMaxEventDays = (startDate, endDate) => {
        if (!startDate || !endDate) return 1;
        
        const start = new Date(startDate);
        const end = new Date(endDate);
        const diffTime = Math.abs(end - start);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 to include both start and end days
        
        return Math.min(diffDays, 10); // Max 10 days
    };

  useEffect(() => {
    fetchTicketDetails();
  }, [ut_id]);

  const formatEventDate = (start, end, time, ticketDate, purchase_date) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffInMs = endDate - startDate; // Difference in milliseconds
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24); // Convert to days
    const day = `${diffInDays + 1}`.toLowerCase();

    const startDay = format(startDate, "dd");
    const endDay = format(endDate, "dd");
    const endmonth = format(endDate, "MMMM");
    const startmonth = format(startDate, "MMMM");
    const year = format(startDate, "yyyy");
    let daysCount = day;
    if (day > 1) {
      daysCount = "10";
    }

    const ticket_date = new Date(ticketDate);
    const ticketDay = format(ticket_date, "dd");

    const purchaseDate = new Date(purchase_date);
    const purchaseDay = format(purchaseDate, "dd");
    const purchaseMonth = format(purchaseDate, "MM");
    const purchaseYear = format(purchaseDate, "yyyy");
    const formatedPurchaseDate = `${purchaseDay}/${purchaseMonth}/${purchaseYear}`;

    if (startDay == endDay) {
      return {
        formattedDate: `${startDay} ${startmonth} ${year}`,
        daysCount: `${daysCount} Day's Event`,
        time,
        ticketFormatedDate: `${ticketDay} ${startmonth} ${year}`,
        formatedPurchaseDate,
      };
    }

    return {
      formattedDate: `${startDay} ${startmonth} - ${endDay} ${endmonth} ${year}`,
      daysCount: `${daysCount} Day's Event`,
      time,
      ticketFormatedDate: `${ticketDay} ${startmonth} ${year}`,
      formatedPurchaseDate,
    };
  };

  if (!detail) return <Typography>No ticket details found.</Typography>;

  let formatedData = {};
  if (!loading) {
    formatedData = formatEventDate(
      detail.start_datetime,
      detail.end_datetime,
      detail.time,
      detail.event_ticket_date,
      detail.purchase_date
    );
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid2 className="center-App" container direction="column">
        <HeaderBack name="Resell Event Details" eventimg={detail.banner} />
        {AlertData.message !== "" ? (
          <Snackbars variant={AlertData.variant} message={AlertData.message} />
        ) : (
          ""
        )}
        {loading ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              minHeight: "300px",
            }}
          >
            <CircularProgress color="primary" />
            <p>Loading ...</p>
          </Box>
        ) : (
          <Box sx={{ padding: "15px 15px", float: "left", width: "100%" }}>
            <Grid2 container spacing={2}>
              <Grid2 item xs={12} sx={{ float: "left", width: "100%" }}>
                <Grid2 className="events-time">
                  {" "}
                  <Typography
                    sx={{ fontWeight: 500, color: "#6638A2", fontSize: "19px" }}
                  >
                    {maxEventDays}  Day's Event
                  </Typography>
                </Grid2>
                <Typography
                  variant="h2"
                  className="title"
                  sx={{
                    marginBottom: "-5px",
                    fontSize: "32px",
                    marginTop: "20px",
                    color: "#6638A2",
                    fontWeight: "500",
                  }}
                >
                  {" "}
                  {detail.name}
                </Typography>
              </Grid2>
              <Grid2 item xs={12} className="fullWidth">
                <Typography
                  variant="h4"
                  className="title"
                  sx={{ marginTop: "20px" }}
                >
                  Ticket Information
                </Typography>
                <Grid2 className="event-info">
                  <Grid2 className="event-des fullWidth">
                    <Typography
                      sx={{
                        color: "#747688",
                        fontSize: "13px,",
                        fontWeight: "500",
                      }}
                    >
                      Ticket Type
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "19px",
                        fontWeight: 500,
                        color: "#120D26",
                      }}
                    >{`${detail.type} Ticket, ${detail.day_pass} Day Pass, ${detail.quantity} Person`}</Typography>
                  </Grid2>
                </Grid2>
                <Grid2 className="event-info">
                  <Grid2 className="event-des fullWidth">
                    <Typography
                      sx={{
                        color: "#747688",
                        fontSize: "13px,",
                        fontWeight: "500",
                      }}
                    >
                      Event Date/Time
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "19px",
                        fontWeight: 500,
                        color: "#120D26",
                      }}
                    >
                      {detail.day_pass == 1
                        ? formatedData.ticketFormatedDate +
                          ", " +
                          formatedData.time
                        : formatedData.formattedDate + ", " + formatedData.time}
                    </Typography>
                  </Grid2>
                </Grid2>
                <Grid2 className="event-info event-info-half-width">
                  <Grid2 className="event-des fullWidth">
                    <Typography
                      sx={{
                        color: "#747688",
                        fontSize: "13px,",
                        fontWeight: "500",
                      }}
                    >
                      Purchase Price
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "19px",
                        fontWeight: 500,
                        color: "#120D26",
                      }}
                    >
                      {detail.purchase_price}
                    </Typography>
                  </Grid2>
                </Grid2>
                <Grid2 className="event-info event-info-half-width">
                  <Grid2 className="event-des fullWidth">
                    <Typography
                      sx={{
                        color: "#747688",
                        fontSize: "13px,",
                        fontWeight: "500",
                      }}
                    >
                      Purchase Date
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "19px",
                        fontWeight: 500,
                        color: "#120D26",
                      }}
                    >
                      {formatedData.formatedPurchaseDate}
                    </Typography>
                  </Grid2>
                </Grid2>

                <Grid2 className="event-info">
                  <Grid2 className="event-des fullWidth">
                    <Typography
                      sx={{
                        color: "#747688",
                        fontSize: "13px,",
                        fontWeight: "500",
                      }}
                    >
                      Location
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "19px",
                        fontWeight: 500,
                        color: "#120D26",
                      }}
                    >
                      {detail.address}
                    </Typography>
                  </Grid2>
                </Grid2>
  
                <Grid2 className="event-info event-info-half-width">
                  <Grid2 className="event-des fullWidth">
                    <Typography
                      sx={{
                        color: "#747688",
                        fontSize: "13px,",
                        fontWeight: "500",
                      }}
                    >
                      Available Tickets
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "19px",
                        fontWeight: 500,
                        color: "#120D26",
                      }}
                    >
                      {`${detail.quantity-detail.resold_quantity}`}
                    </Typography>
                  </Grid2>
                </Grid2>

                <Grid2 className="event-info event-info-half-width">
                  <Grid2 className="event-des fullWidth">
                    <Typography
                      sx={{
                        color: "#747688",
                        fontSize: "13px,",
                        fontWeight: "500",
                      }}
                    >
                      Resell Tickets
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "19px",
                        fontWeight: 500,
                        color: "#120D26",
                      }}
                    >
                      {`${detail.resold_quantity}`}
                    </Typography>
                  </Grid2>
                </Grid2>

                {/* <Grid2 className="event-info">
                                <Grid2 className="event-des fullWidth">
                                    <Typography sx={{ color: "#747688", fontSize: "13px,", fontWeight: "500" }}>Buying Ticket Price</Typography>
                                    <Typography sx={{ fontSize: "23px", fontWeight: 500, color: "#028E54" }}>₹ {eventDetails.price}</Typography>
                                </Grid2>
                            </Grid2> */}
              </Grid2>
              {/* <Grid2 item xs={12} className="fullWidth" sx={{ marginTop: "12px", marginBottom: "20px" }}>
                            <Typography variant="h4" className="title" sx={{ marginBottom: '15px' }}>About</Typography>
                            <Typography className="event-des">{eventDetails.description}</Typography>
                            <Link onClick={handleClickOpen} className="read-more">Read More</Link>
                        </Grid2> */}
            </Grid2>
            {
              <Grid2
                className="event-info fullWidth"
                sx={{ marginTop: "40px" }}
              >
                <form className="loginForm">
                  <div className="position-relative">
                    <img
                      src={rupee}
                      alt="Logo"
                      width={24}
                      className="textboxLefticonRupee"
                    />
                    <TextField
                      type="number"
                      name="selling_price"
                      className={`form-control ${
                        validation1.touched.selling_price &&
                        validation1.errors.selling_price
                          ? "is-invalid"
                          : ""
                      }`}
                      value={validation1.values.selling_price || ""}
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      placeholder="Set Selling Price"
                      autoComplete="off"
                      onChange={validation1.handleChange}
                      invalid={
                        validation1.touched.selling_price &&
                        validation1.errors.selling_price
                          ? true
                          : false
                      }
                    />
                    {validation1.touched.selling_price &&
                    validation1.errors.selling_price ? (
                      <div className="invalid-feedback">
                        {validation1.errors.selling_price}
                      </div>
                    ) : null}
                  </div>
                  <Grid2
                    item
                    xs={12}
                    className="fullWidth"
                    sx={{ marginBottom: "20px" }}
                  >
                    <Typography
                      sx={{
                        fontSize: "17px",
                        fontWeight: 500,
                        color: "#120D26",
                      }}
                    >
                      Please enter a resale price between{" "}
                      <Typography variant="span" sx={{ color: "#6638A2" }}>
                        ₹ {detail.resell_min * quantity}
                      </Typography>{" "}
                      and{" "}
                      <Typography variant="span" sx={{ color: "#6638A2" }}>
                        ₹ {detail.resell_max * quantity}
                      </Typography>
                    </Typography>
                    {/* <Typography className="event-des">Please enter a resale price between <Typography  className="title" sx={{ marginTop: '20px' }}>500</Typography></Typography> */}
                    {/* <Link onClick={handleClickOpen} className="read-more">Read More</Link> */}
                  </Grid2>
                  <Grid item xs={12}>
                    <FormControl fullWidth className="custom-quantity">
                      <Typography className="lable-title">Quantity</Typography>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        border={1}
                        borderRadius={4}
                        overflow="hidden"
                      >
                        <Button onClick={handleDecrement}>
                          <img src={Minus} alt="" />
                        </Button>
                        <Typography
                          variant="body1"
                          sx={{
                            flex: 1,
                            textAlign: "center",
                            padding: "8px",
                            backgroundColor: "rgba(128, 0, 128, 0.1)",
                            color: "purple",
                          }}
                        >
                          {String(quantity).padStart(2, "0")}
                        </Typography>
                        <Button onClick={handleIncrement}>
                          <img src={Plus} alt="" />
                        </Button>
                      </Box>
                    </FormControl>
                  </Grid>
                  <Grid2
                    className="button-bottom fullWidth"
                    fullWidth
                    sx={{ marginTop: "25px" }}
                  >
                    <Button
                      className="btn-common"
                      variant="contained"
                      color="primary"
                      fullWidth
                      sx={{ marginTop: "12px" }}
                      onClick={async () => {
                        const isValid = await validation1.validateForm();
                        await validation1.setTouched({ selling_price: true });
                        if (!validation1.errors.selling_price) {
                          setOpen(true);
                        }
                      }}
                    >
                      Resell Ticket
                    </Button>

                  </Grid2>
                </form>
              </Grid2>
            }
          </Box>
        )}
      </Grid2>
      {/* <Dialog open={open} onClose={handleClose} aria-labelledby="">
        <DialogTitle className="Modal-title">About Events</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            olor: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText
            sx={{
              color: "#341439",
              fontSize: "18px",
              lineHeight: "31px",
              marginBottom: "10px",
            }}
          >{`Please enter a resale price between ₹ 500 and ₹ 2500`}</DialogContentText>
        </DialogContent>
      </Dialog> */}
      <Dialog open={open} onOpenChange={setOpen}>
        <div
          className="install-modal"
          style={{
            zIndex: 111,
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: "white",
              padding: "25px 10px 30px",
              borderRadius: "10px",
              textAlign: "center",
              width: "100%",
              maxWidth: "430px",
              margin: "0 10px",
            }}
          >
            <p style={{ fontSize: "20px", marginTop: "8px" }}>
              Are you sure you want to resell this ticket?
            </p>
            <button
              id="submit1"
              onClick={(e) => {
                e.preventDefault();
                setOpen(false);
                validation1.handleSubmit()
                return false;
              }}
              style={{
                background: "#6638A2",
                border: "none",
                padding: "4px 25px",
                fontSize: "18px",
                color: "#fff",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Resell
            </button>
            <button
              onClick={() => setOpen(false)}
              style={{
                marginLeft: "10px",
                background: "#EFEFEF",
                border: "none",
                padding: "4px 25px",
                fontSize: "18px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </Dialog>
    </Box>
  );
};

export default Myeventsdetails;
